import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=668578da&scoped=true"
import script from "./Block.vue?vue&type=script&lang=ts"
export * from "./Block.vue?vue&type=script&lang=ts"
import style0 from "./Block.vue?vue&type=style&index=0&id=668578da&prod&lang=scss&scoped=true"
import style1 from "./Block.vue?vue&type=style&index=1&id=668578da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668578da",
  null
  
)

export default component.exports